export enum PayPeriodTypeEnum {
    Hourly = 1,
    Daily = 2
}
